import React, {useEffect, useState} from "react";
import {Bar} from "react-chartjs-2";
import {BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip} from "chart.js";
import {getEmployeeReportData} from "../../Api/Api";
import {useNotification} from "../Notification/NotificationContext";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const EmployeeReportChart = ({ employeeId, workshopId }) => {
    const [chartData, setChartData] = useState(null)
    const { showNotification } = useNotification();

    useEffect(() => {
        const fetchData = async () => {
            let data;
            try {
                getEmployeeReportData(employeeId, workshopId)
                    .then((res) => {
                         generateChart(res.data);
                    })
                    .catch((error) =>   showNotification(error.message, "error"));


                // Extract labels (Months) and values (Completed Jobs)

            } catch (error) {
                showNotification(error.message, "error")
            }
        };

        fetchData();
    }, [employeeId]);

    const generateChart = (data) => {
        const labels = data.map((item) => `${item.month}-${item.year}`);
        const completedJobs = data.map((item) => item.completedJobs);
        const avgTimePerJob = data.map((item) => item.avgTimePerJob);
        const totalTimeSpent = data.map((item) => item.totalTimeSpent);

        setChartData({
            labels,
            datasets: [
                {
                    label: "Completed Jobs",
                    data: completedJobs,
                    backgroundColor: "rgba(75, 192, 192, 0.6)",
                },
                {
                    label: "Avg Time Per Job (min)",
                    data: avgTimePerJob,
                    backgroundColor: "rgba(255, 99, 132, 0.6)",
                },
                {
                    label: "Total Time Spent (min)",
                    data: totalTimeSpent,
                    backgroundColor: "rgba(54, 162, 235, 0.6)",
                },
            ],
        });
    }

    return (
        <div>
            {chartData ? (
                <Bar
                    data={chartData}
                    options={{
                        responsive: true,
                        plugins: {
                            legend: {
                                position: "top",
                            },
                            title: {
                                display: true,
                                text: "Employee Performance Over Time",
                            },
                        },
                    }}
                />
            ) : (
                <p>Loading...</p>
            )}
        </div>
    );
};

export default EmployeeReportChart;
